import React, {Fragment, useEffect, useState} from "react";

import './RadioButtonGroup.scss';

const RadioButtonGroup = ({onChange, values, name, initialValue, readOnly}) =>
{
   const [ selected, setSelected ] = useState ( initialValue ) ;
   useEffect(() => {
      setSelected ( initialValue );
   }, [initialValue]);

   const localOnChange =  ( e ) =>
   {
      const { name, value } = e.target;

      setSelected(+value) ;

      onChange(+value) ;
   }

   const isSelected = (offset) =>
   {
      return selected === offset ;
   }

   const buttons = ( values ) =>
   {
      return values.map ((value, index) =>
      {
         const checked = selected === null || selected === undefined ? false : +value.offset === +selected ;

         return (
             <div className="form-check" key={index}>
                <input className="form-check-input" type="radio" checked={checked} disabled={readOnly} value={+value.offset} name={name} key={name} id={name + index } onChange={localOnChange}/>
                   <label className="form-check-label" htmlFor={name + index }>
                      {value.label}
                   </label>
             </div>
         )
      })
   }

   return (
      <div key='rnd'>
         {buttons(values)}
      </div>
   )
}
export { RadioButtonGroup } ;